exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.template-item {\n  cursor: pointer;\n  padding: .25em .25em .25em .5em;\n  width: 100%;\n}\n.template-item > .img {\n  width: 48px;\n}\n.template-item > span {\n  line-height: 1.2em;\n  padding-left: .5em;\n}\n.selected-item .template-item > .img {\n  width: 36px;\n}\n.dropdown .template-item:hover {\n  background-color: #dee7ef;\n  color: #222;\n}\n.dropdown .current-item {\n  background-color: #00549d;\n  color: #FFF;\n}\n", ""]);

// exports
